import { render, staticRenderFns } from "./OnetoOneReg.vue?vue&type=template&id=43aa42ac&scoped=true"
import script from "./OnetoOneReg.vue?vue&type=script&lang=js"
export * from "./OnetoOneReg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43aa42ac",
  null
  
)

export default component.exports